import React from "react"
import Img from "gatsby-image"
import { Card } from "reactstrap"
import { Link, useStaticQuery, graphql } from "gatsby"

const Card2 = () => {
  const data = useStaticQuery(graphql`
    {
      file(relativePath: { eq: "m2.jpg" }) {
        id
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <Card className="menu-image" key={data.file.id} inverse>
      <div className="over-menu">
        <h3>
          <Link className="btn my-button" to="/catering-menu">
            <span className="myover">Catering Menu</span>
          </Link>
        </h3>
      </div>
      <Img
        className="card-img-top"
        fluid={data.file.childImageSharp.fluid}
        objectFit="cover"
      />
    </Card>
  )
}

export default Card2
